
    import { defineComponent } from 'vue';
    export default defineComponent({
        name: 'loading-card',
        props:{
            loading: {
                type: Boolean,
                default: true,
            },
            itemsLength: {
                type: Number,
                default: 0,
            },
        }
        
    });
